"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPaymentInterApi = exports.isLambdaResponseError = exports.isLambdaCheckoutResponseSuccess = exports.isLambdaResponseSuccess = void 0;
const company_1 = require("../company");
const isLambdaResponseSuccess = (r) => {
    return r.statusCode === 200;
};
exports.isLambdaResponseSuccess = isLambdaResponseSuccess;
const isLambdaCheckoutResponseSuccess = (r) => {
    return r.statusCode === 200;
};
exports.isLambdaCheckoutResponseSuccess = isLambdaCheckoutResponseSuccess;
const isLambdaResponseError = (r) => {
    return r.statusCode === 400;
};
exports.isLambdaResponseError = isLambdaResponseError;
const isPaymentInterApi = (r, p) => {
    return p === company_1.PaymentTypes.API_INTER;
};
exports.isPaymentInterApi = isPaymentInterApi;
